import config from 'config';
import sfax from './sfax';
import md5 from 'assets/util/kft-md5'
import graphqlRequest from './graphql'

var $ = window.$;

const { domain, esfDomain, graphqlDomain, sohuShipinUrl, videoUrl,relayDomain } = config;

export default {
    loupanKanfangGet: payload => sfax({
        url: '/baseApi/getkanFangTuanInfo',
        withCredentials: false,
        data: payload,
    }),
    getEsfRecomdInfo: payload => sfax({
        url: `${esfDomain}/beike/api/getNearByRegions.jsonp`,
        data: payload.data,
        jsonp: true,
        callbackname: 'function'
    }),
    getPhoneQrcode: payload => {
        return graphqlRequest({
            path: '/baseApi/getPhoneQRCode',
            query: payload
        }).then((res) => {
            const {
                data
            } = res
            const result = {
                code: 1
            }
            if (data) {
                result.code = 200
                result.data = 'https://t.focus-img.cn' + data.projectDetails.phoneQrCode
            }
            return Promise.resolve(result)
        })
        // sfax({
        //     url: '/baseApi/getPhoneQRCode',
        //     data: payload
        // })
    },
    postLoupanKpbj: payload => {
        return graphqlRequest({
            path: '/baseApi/subscribe',
            query: payload
        }).then((res) => {
            const {
                data
            } = res
            const result = {
                code: 1
            }
            if (data) {
                result.code = data.userAction.commitSubscribe.code
                result.msg = data.userAction.commitSubscribe.msg
            }
            return Promise.resolve(result)
        })
        // sfax({
        //     url: '/baseApi/subscribe',
        //     type: 'post',
        //     data: payload
        // })
    },
    postLoupanKanfang: payload => {
        return graphqlRequest({
            path: '/baseApi/kanFangTuanApplyNew',
            query: payload
        }).then((res) => {
            const {
                data
            } = res
            const result = {
                code: 1
            }
            if (data) {
                result.code = data.userAction.kanFangTuanApplyNew.code
                result.msg = data.userAction.kanFangTuanApplyNew.msg
            }
            return Promise.resolve(result)
        })
        // sfax({
        //     url: '/baseApi/kanFangTuanApplyNew',
        //     type: 'post',
        //     data: payload
        // })
    },
    postLoupanBaoming: payload => {
        return graphqlRequest({
            path: '/baseApi/kanFangTuanApply',
            query: payload
        }).then((res) => {
            const {
                data
            } = res
            const result = {
                code: 1
            }
            if (data) {
                result.code = data.userAction.kanFangTuanApply.code
                result.msg = data.userAction.kanFangTuanApply.msg
            }
            return Promise.resolve(result)
        })
        // sfax({
        //     url: '/baseApi/kanFangTuanApply',
        //     type: 'post',
        //     data: payload
        // })
    },
    getMpAgentQrCode: payload => sfax({
        url: '/baseApi/getPfdACode',
        data: payload
    }),
    videoPlayCount: payload => sfax({
        url: `${videoUrl}/api/video/addPlayCount`,
        data: payload
    }),
    videoPlayCountIe: payload => $.getJSON(`${videoUrl}/api/video/addPlayCount?callback=?`, payload, function(data) {
        return data
    }),
    getVideoList: payload => fetchDataNormal('/loupan/video', payload),
    getVideoUrl: payload => getVideoUrlFromSohu(payload),
    loupanListClueSend: payload => loupanListClueSend(payload),
    loupanClueSend: payload => loupanClueSend(payload),
    goodHouseSelector: payload => goodHouseSelector(payload),
};

function joinEqul(params) {
    let paramsList = [];
    for (let key in params) {
        paramsList.push(`${key}=${params[key]}`)
    }
    return paramsList.join('&')
}

function fetchDataNormal(path, query) {
    return sfax({
        url: `${graphqlDomain}/alias/query`,
        data: {
            name: path,
            graphProjectId: 6,
            param: joinEqul(query)
        },
        jsonp: true,
        callbackname: 'function'
    })
}

function getVideoUrlFromSohu(params) {
    const t = new Date().getTime()
    const key = 'as1S82@a#!sas.30aA'
    const cn = 'focus_miniPro'
    const sign = md5(cn + '@' + t + '@' + key)
    return sfax({
        url: `${sohuShipinUrl}/v2/video/play.do?_src=partner&_cn=${cn}&_sig=${sign}&_ts=${t}&`,
        data: params,
        'Content-Type': 'application/x-www-form-urlencoded',
        jsonp: true,
        callbackname: 'function'
    })
}
function loupanListClueSend(params){
    return sfax({
        url: `${relayDomain}/api/clueSendByMobile`,
        data: params,
    })
}
function loupanClueSend(params){
    return sfax({
        url: `${relayDomain}/api/loupanClueSend`,
        data: params,
    })
}
function goodHouseSelector(param) {
    return sfax({
        url: `${graphqlDomain}/alias/query`,
        data: {
            graphProjectId: 7,
            name: '/api/good-house-seletor',
            param: 'cityId=' + param
        },
        // jsonp: true,
        // callbackname: 'function'
    })
}


// WEBPACK FOOTER //
// ./src/model/api/loupan.js